import { Filter } from "../components/report/models/filter.model";
import { Report } from "../components/report/models/report.model";
import { FilterTypeEnum } from "../enums/filter-type.enum";
import { sortListByOrder } from "./column.helper";

export function getFilterByName(filters: Filter[], name: string): Filter {
    return filters.find(x => x.Name === name);
}

export function getAllFilters(report: Report): Array<Filter> {
    let filters = [];
    if (report) {
      report.Entities.forEach(entity => {
        entity.Filters.forEach(filter => {

          if (filter.Type === FilterTypeEnum.Between) {
            SetBetweenFilters(filter, filters);
          } else {
            filters.push(filter);
          }
        });
      });
    }
    filters = sortListByOrder(filters);
    return filters;
  }

export function SetBetweenFilters(filter: Filter, filters: Array<Filter>) {
    const auxEnd = {... filter},
     auxIni =  {... filter};

    auxEnd.Legend = '';
    auxEnd.Name = `${auxEnd.Name}_FIN`;
    auxIni.Name = `${auxIni.Name}_INI`;

    filters.push(auxIni);
    filters.push(auxEnd);
}